import {PropsWithChildren} from "react";
import {generatePath, Navigate, useParams} from "react-router-dom";
import {useQuestionnaireVariant} from "~/new-design/hooks";
import {urls} from "~/routes/consumerUrls";

export const QuestionnaireVariantGate = ({children}: PropsWithChildren) => {
  const isQuestionnaire = useQuestionnaireVariant();
  const {accountId = ""} = useParams<{accountId: string}>();
  if (!isQuestionnaire) return <Navigate to={generatePath(urls.picker.url, {accountId})} replace />;
  return <>{children}</>;
};
